import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';

// The native <select>, styled to match Input so the two line up in a form. Promoted here from the
// exam editor once the start-test dialog needed the same control.
//
// Deliberately native rather than a listbox built out of divs: it is a plain single choice, and
// the platform control already handles keyboard, screen readers and the mobile picker better than
// a hand-rolled one would.
//
// forwardRef is load-bearing, not cosmetic: spread with react-hook-form's register(), the ref it
// returns is how RHF reads the live value. A plain function component drops it silently and the
// field submits undefined the moment someone actually picks an option (see FederationsPage's
// TimezoneSelect, which had exactly that bug).
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className = '', ...props }, ref) {
    return (
      <select
        ref={ref}
        className={
          'h-9 w-full rounded-btn border-[1.5px] border-line bg-surface px-3 text-[13px] text-ink ' +
          'focus:border-accent focus:outline-none ' +
          className
        }
        {...props}
      />
    );
  },
);
